export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6186.3cd39a54.jpg";